export interface PasswordRule {
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { label: 'One uppercase letter (A-Z)', test: (p) => /[A-Z]/.test(p) },
  { label: 'One lowercase letter (a-z)', test: (p) => /[a-z]/.test(p) },
  { label: 'One digit (0-9)', test: (p) => /\d/.test(p) },
  { label: 'One special character (!@#$%...)', test: (p) => /[^A-Za-z0-9]/.test(p) },
];

/**
 * Validates a password against all complexity rules.
 * Returns null if valid, or a human-readable error message for the first failing rule.
 */
export function validatePassword(password: string): string | null {
  for (const rule of PASSWORD_RULES) {
    if (!rule.test(password)) {
      return `Password must contain: ${rule.label.toLowerCase()}`;
    }
  }
  return null;
}

/**
 * Returns the number of rules the password currently passes (0 to PASSWORD_RULES.length).
 */
export function getPasswordStrength(password: string): number {
  return PASSWORD_RULES.filter((rule) => rule.test(password)).length;
}
